export default __webpack_public_path__ + "static/media/Lunch.b4334fe1.jpeg";